import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./CreateServiceFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";

import "./CreateServiceForm.scss";
import { getDateFromISO } from "../../../../../Utils/ServiceUtils/ServiceUtils";
import CreateServiceFormStepOne from "./Steps/CreateServiceFormStepOne";
import CreateServiceFormStepTwo from "./Steps/CreateServiceFormStepTwo";

const CreateServiceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        serviceBase: _initialValues?.device?.serviceBase?.uuid
          ? { value: _initialValues?.device?.serviceBase?.uuid }
          : null,
        requester: _initialValues?.requester?.uuid
          ? {
              ..._initialValues?.requester,
              label: _initialValues?.requester?.name,
              uuid: _initialValues?.requester?.uuid,
            }
          : null,
        preferredTechnician: _initialValues?.preferredTechnician?.uuid
          ? {
              value: _initialValues.preferredTechnician.uuid,
              name: `${_initialValues.preferredTechnician.firstName} ${_initialValues.preferredTechnician.lastName}`,
              uuid: _initialValues.preferredTechnician.uuid,
            }
          : null,
        technicianOrTeamLeader: _initialValues?.technicianOrTeamLeader?.uuid
          ? {
              value: _initialValues.technicianOrTeamLeader.uuid,
              name: `${_initialValues.technicianOrTeamLeader.firstName} ${_initialValues.technicianOrTeamLeader.lastName}`,
              uuid: _initialValues.technicianOrTeamLeader.uuid,
            }
          : null,
        techniciansInTheGroup:
          _initialValues?.techniciansInTheGroup?.map((t) => ({
            value: t.uuid,
            uuid: t.uuid,
            name: `${t.firstName || ""} ${t.lastName || ""}`,
          })) || [],

        problemDescriptionsDictionary:
          _initialValues?.problemDescriptionsDictionary?.map((p) => ({
            value: p.uuid,
            label: p.entryName,
            uuid: p.uuid,
          })) || [],
        tasksDictionary:
          _initialValues?.tasksDictionary?.map((t) => ({
            value: t.uuid,
            label: t.entryName,
            uuid: t.uuid,
          })) || [],
        additionalInfo:
          _initialValues?.additionalInfo?.map((t) => ({
            value: t.uuid,
            label: t.entryName,
            uuid: t.uuid,
          })) || [],
        plannedServiceTime: getDateFromISO(
          _initialValues?.plannedServiceDateTime,
        ),
        expectedServiceTime: getDateFromISO(
          _initialValues?.expectedServiceDateTime,
        ),
      });
      return;
    }

    setInitialValues({
      workImpact: "NoInformation",
      location: "noInformation",
    });
    // eslint-disable-next-line
  }, []);

  if (!initialValues) return null;
  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={false}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="CreateServiceForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <CreateServiceFormStepOne
                {...formProps}
                {...props}
                update={update}
              />
              <CreateServiceFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default CreateServiceForm;
